import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CompanyOverview from './components/CompanyOverview';
import Services from './components/Services';
import Strengths from './components/Strengths';
import CaseStudies from './components/CaseStudies';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <CompanyOverview />
      <Services />
      <Strengths />
      <CaseStudies />
      <News />
      <Contact />
      <Footer />
    </div>
  );
}
